<template>
  <div
    id="commentBox"
    class="more_box box-absolute position-absolute mdc-menu mdc-menu-surface toggle-menu"
    :class="className"
    style="display: block"
  >
    <ul
      aria-hidden="true"
      aria-orientation="vertical"
      class="mdc-list chat-modal-list"
      role="menu"
      tabindex="-1"
      id="chatModalList"
    >
      <!-- report comment -->
      <li
        v-if="!data.owner && !isOwner && type !== 'CHAT'"
        class="cursor-pointer mdc-list-item"
        role="menuitem"
        tabindex="0"
        @click="report"
        @keypress="report"
      >
        <span class="mdc-list-item__ripple"></span>
        <span class="mdc-list-item__text t-body6 font-r">
          {{ $t("3136") }}
        </span>
      </li>

      <!-- block user -->
      <li
        v-if="!data.owner && !isOwner"
        class="cursor-pointer mdc-list-item"
        role="menuitem"
        tabindex="0"
        @click="block"
        @keypress="block"
      >
        <span class="mdc-list-item__ripple"></span>
        <span class="mdc-list-item__text t-body6 font-r">
          {{ isBlocked ? $t("3815") : $t("3789") }}
        </span>
      </li>

      <!-- modify comment -->
      <li
        v-if="
          selectedChild &&
          selectedChild.modify === true &&
          (data.owner || isOwner)
        "
        class="cursor-pointer mdc-list-item"
        role="menuitem"
        tabindex="0"
        @click="edit"
        @keypress="edit"
      >
        <span class="mdc-list-item__ripple"></span>
        <span class="mdc-list-item__text t-body6 font-r">{{ $t("3137") }}</span>
      </li>
      <!-- delete comment -->
      <li
        v-if="
          selectedChild &&
          selectedChild.remove === true &&
          (data.owner || isOwner)
        "
        class="cursor-pointer mdc-list-item"
        role="menuitem"
        tabindex="0"
        @click="deleteFunc"
        @keypress="deleteFunc"
      >
        <span class="mdc-list-item__ripple"></span>
        <span class="mdc-list-item__text t-body6 font-r">{{ $t("3138") }}</span>
      </li>
    </ul>
  </div>
</template>
  
  <script>
/**
 * type          : (required) BOARD, COMMENT, REPLY, CHAT
 * data          : (required) 해당 리스트의 엘리멘트
 * selectedChild : (required) 상위 컴포넌트에서 선택받은 데이터인지 확인 하는 state
 * parent        : (option) Reply이면 parent데이터가 있음
 * className     : (option) class
 * emit으로 함수 전달
 * report
 * block
 * edit
 * delete
 */
export default {
  name: "UserDetailActionModal",

  props: ["type", "parentData", "selectedChild", "data", "className"],

  watch: {
    data: {
      handler(value) {
        this.isBlocked = value.isBlocked;
      },
    },
  },

  data() {
    return {
      isBlocked: false,
      isOwner: false,
    };
  },

  mounted() {
    if (this.data.reviewer && this.data.reviewer.email) {
      const dataEmail = this.data.reviewer.email;
      const userId = JSON.parse(localStorage.getItem("userParams")).userId;
      if (dataEmail === userId) {
        this.isOwner = true;
      }
    }
    this.isBlocked = this.data.isBlocked;
  },

  methods: {
    report() {
      // 게시글 emit
      if (this.type === "BOARD") {
        this.$emit("report", this.data);
      }

      // 댓글 emit (social learning은 마지막 파라미터 받음)
      if (this.type === "COMMENT") {
        return this.$emit("report", this.data);
      }

      // 대댓글 emit
      if (this.type === "REPLY") {
        return this.$emit("report", this.data);
      }

      if (this.type === "REVIEW") {
        return this.$emit("report", this.data);
      }
    },

    block() {
      this.$emit("block", this.data, this.data.isBlocked);
    },

    edit(evt) {
      // 게시글 emit
      if (this.type === "BOARD") {
        this.$emit("edit");
      }

      // 댓글 emit
      if (this.type === "COMMENT") {
        return this.$emit("edit", this.data);
      }

      // 대댓글 emit
      if (this.type === "REPLY") {
        return this.$emit(
          "edit",
          this.data,
          this.parentData.id,
          evt,
          this.parentData.auditor.register.name.fullName
        );
      }

      // Review emit
      if (this.type === "REVIEW") {
        return this.$emit("edit", this.data.id);
      }
    },

    deleteFunc(evt) {
      // 게시글 emit
      if (this.type === "BOARD") {
        this.$emit("delete");
      }

      // 댓글 emit
      if (this.type === "COMMENT") {
        return this.$emit("delete", this.data.id, 0);
      }

      // 대댓글 emit
      if (this.type === "REPLY") {
        return this.$emit("delete", this.data.id, this.parentData.id, evt);
      }

      // Review emit
      if (this.type === "REVIEW") {
        this.$emit("delete", this.data.id);
      }
    },
  },
};
</script>
  
  <style scoped>
ul {
  margin: 0 !important;
}

.box-absolute {
  z-index: 1000;
}
</style>